import { Container, Heading, Grid } from 'theme-ui';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const Accolades = ({ section, forwardSX = {} }) => {
  const { title, images, backgroundColor } = section;
  const oneline = images.length % 2 !== 0;
  return (
    <Container
      variant="fullwidth"
      color="white"
      sx={{
        pt: ['4rem', null, '7.2rem'],
        pb: ['7.2rem', null, '10.4rem'],
        px: ['4rem', null, '9.6rem'],
        backgroundColor: backgroundColor ?? 'black',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...forwardSX,
      }}
    >
      {title ? (
        <Heading
          as="h3"
          sx={{
            fontSize: '2.8rem',
            textTransform: 'uppercase',
            fontWeight: 'medium',
            lineHeight: '100%',
            letterSpacing: '-2%',
            mb: ['4.8rem', null, '10.4rem'],
          }}
        >
          {title}
        </Heading>
      ) : null}

      <Grid
        sx={{
          columnGap: ['4rem', null, oneline ? '4.8rem' : '9.6rem'],
          rowGap: '9.6rem',
          alignItems: 'center',
          gridTemplateColumns: ['repeat(3, 1fr)', `repeat(${images.length}, minmax(min-content, 16rem))`],
          placeItems: 'center',
        }}
      >
        {images.map((image) => (
          <GatsbyImage key={image.id} image={getImage(image)} alt={`${image.title}'s logo`} />
        ))}
      </Grid>
    </Container>
  );
};

export default Accolades;
